<template>
    <div id="exercises">
        <b-row class="backInfoMain2">

            <s-menuSave :msg="sendMsg" newBtn :btnSaveDisabled="checkAllField" @new="menuNew()" saveBtn @save="menuSave()" :deleteBtn="checkDeleteBtn" @delete="menuDelete(activeObj.id)"></s-menuSave>

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                <s-itemList
                    v-if="fromApi" 
                    :content="fromApi" 
                    :returnValue.sync="activeObj" 
                    showField="description0" 
                    activeField="isActive" 
                    returnField="id"
                    :selectedItems="activeObj"
                    getSubCol=""
                    :fields="fields">
                </s-itemList>
            </b-col>
            <!--Fin section de gauche-->

<!--****************************************************************************************************************************************************************-->
            
            <!--Section de centre-->
            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" :xl="3">
                <!--{{fromApi}}<br><br><br>
                {{activeObj}}-->
                
                <!--ACTIF-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('cmp_Actif')}}</div>
                            <div class="itemContain">
                                <s-duoSelector style="margin-left: -15px" :text1="$t('cmp_Actif')" :text2="$t('cmp_Inactif')" invertTrueFalse :value="activeObj.isActive" :returnValue.sync="activeObj.isActive"></s-duoSelector>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - ACTIF-->

                <!--DATES Ouverture / Fermeture-->
                <b-row>
                    <b-col :class="getAllSize.pagePadTop" xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('g_Date')}}</div>
                            <div class="itemContain">
                                <!--Date de début-->
                                <!--<b-row>
                                    <b-col xs="12" sm="12" md="12" lg="8" :xl="$dateSize1()">
                                            <s-datePicker 
                                                name="startDate" 
                                                :dateValue.sync="activeObj.startDate"
                                                style="margin-top: 5px" >
                                            </s-datePicker>
                                    </b-col>
                                </b-row>-->

                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="8" :xl="$dateSize1()">
                                            <s-monthSelector
                                                name="startDate" 
                                                :title="$t('per_PeriodeDebute')"
                                                style="margin-top: 5px"
                                                v-model="periodStartMonth">
                                            </s-monthSelector><br>
                                    </b-col>
                                </b-row>
                                <!--Date de fin-->
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="8" :xl="$dateSize1()">
                                        <br>
                                            {{$t('per_Debut')}} 
                                            {{$gAccountYear(activeObj.startDate)}}
                                        <br>
                                            {{$t('per_Fin')}} 
                                            {{$gAccountYearAdd(activeObj.startDate)}}
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!-- FIN - DATES Ouverture / Fermeture-->

                <!--DESCRIPTION-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('per_Description')}}</div>
                            <div class="itemContain">
                                <b-form-input class="txtPrincipal" :state="activeObj.description0.length > 0 ? true : false" id="description0" name="description0" type="text" maxlength="255" :placeholder="$t('per_Description1')" v-model="activeObj.description0"></b-form-input>
                                <b-form-input class="txtPrincipal" id="description1" name="description1" type="text" maxlength="255" :placeholder="$t('per_Description2')" v-model="activeObj.description1"></b-form-input>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - DESCRIPTION-->

                <!--NOMBRE DE PERIODES-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('ex_NombreDePeriodes')}}</div>
                            <div class="itemContain">
                                <b-row>
                                    <b-col cols="7" xs="7" sm="7" md="7" lg="7" xl="7" style="margin-left: -15px;">
                                        <b-row align-v="center">
                                            <b-button-group size="md" style="margin-left: 30px">
                                                <b-button :class="this.activeObj.numberOfPeriod == 1 ? 'btnFiltre btnFiltreBackGroundSelect' : 'btnFiltre btnFiltre1'" :variant="getTheme.primary" @click="createPeriods(1)">1</b-button>
                                                <b-button :class="this.activeObj.numberOfPeriod == 4 ? 'btnFiltre btnFiltreBackGroundSelect' : 'btnFiltre btnFiltre2'" :variant="getTheme.info" @click="createPeriods(4)">4</b-button>
                                                <b-button :class="this.activeObj.numberOfPeriod == 12 ? 'btnFiltre btnFiltreBackGroundSelect' : 'btnFiltre btnFiltre1'" :variant="getTheme.primary" @click="createPeriods(12)">12</b-button>
                                            </b-button-group>
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - NOMBRE DE PERIODES-->

            </b-col>
            <!--FIN - Section de centre-->

            <!--Section de droite-->
            <b-col xs="12" sm="12" md="12" lg="12" xl="5">
                
                <!--PERIODES-->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <!--<div class="itemSubTitle">{{$t('ex_Periodes')}}</div>-->
                            <div class="itemContain" style="margin-top: -9px">
                                <span v-for="(item, index) in periodsList" :key="item.index">
                                        <b-col>
                                            <h6 class="subTitle4">{{$t('ex_Periodes')}} : {{parseInt(index) + 1}}</h6>
                                            <b-row>
                                                <b-col>
                                                    Date d'ouverture : {{item.startDate}}<br>
                                                </b-col>
                                                <b-col>
                                                    Date de fermeture : {{item.endDate}}<br>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col>
                                                    Période : {{returnIsClosed(item.isClosed)}}<br>
                                                </b-col>
                                                <b-col>
                                                    Solde : {{$FM(0, 2)}}<br>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                </span>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <!--FIN - PERIODES-->

            </b-col>
            <!--FIN - Section de droite-->

            <br><br>
            
        </b-row>
    </div>
</template>

<script>
import mapGetter from '../../../../mixins/getters.js'
import {dataService} from '@/services'

export default{
    name: "exercises",
    mixins:[mapGetter],
    components: {

    },
    data() {
        return{
            apiAddGet1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiExercises, //adress de la requete principale vers l'API
            apiAddPost1: this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.magasin.apiExercises, //adress de la requete principale vers l'API
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '', //message a utiliser pour le menu en haut de la page New/Save/Delete
            output: 'null', //Message de reception de l'API
            error: null, //Message d'erreur de l'API
            fromApi: null, //Contenu de l'API
            InitialState: null, //Format initial de : activeObj
            periodStartMonth: 1,
            //Objet en cours de modification
            activeObj:{
                id: 0,
                isActive: true,
                dateCreated: null,
                dateModified: null,
                isClosed: false,
                description0: '',
                description1: '',
                startDate: null,
                endDate: null,
                closedDate: null,
                numberOfPeriod: 12
            },
            periodsList: [],
            periods:{
                id: 0,
                isActive: true,
                dateCreated: null,
                dateModified: null,
                exerciseId: 0,
                description0: '',
                description1: '',
                periodNumber: 0,
                isClosed: false,
                startDate: null,
                endDate: null 
            },
            fields: [
                {
                    colName : "id",
                    label: "g_id",
                    width: 75,
                },
                {
                    colName : "description0",
                    alignH : "left",
                    label: "ex_Description",
                    width: 150,
                    show: true,
                }
                
            ],
        }
    },
    methods: {
        pushto(link) {
            this.$router.push(link)
        },
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
        },
        menuNew(){
            this.resetAll()
        },
        loadApi() {
            this.sendMsg = '4'
            dataService.getExercices().then( response =>{
                this.fromApi = response.data.data
                this.sendMsg = ''
            }).catch(e => {
                this.sendMsg = e
            })
        },
        menuSave(){
            this.sendMsg = '-'
            //let currentObj = this;
            let t = this.activeObj

            if (t.id == 0) //CRÉATION D'UN NOUVEAU
            {
                dataService.addExercice(t)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        if(response.data)
                        {
                            const newExercice = response.data.data
                            this.fromApi.unshift(newExercice)
                            this.resetAll()
                        }
                    }
                    this.sendMsg = ''
                })
                .catch((error) => {
                    this.sendMsg = error
                });
            }
            else //MODIFICATION D'UN EXISTANT
            {
                dataService.updateExercice(t)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        if(response.data)
                        {
                            const updatedExercice = response.data.data
                            this.fromApi = this.fromApi.map(exercice => {
                                if(exercice.id == updatedExercice.id)  Object.assign(exercice, updatedExercice) ;
                                return exercice;
                            });
                            this.resetAll()
                        }
                    }
                    this.sendMsg = ''
                })
                .catch((error) => {
                    this.sendMsg = error
                });
            }
                //setTimeout(() => { this.sendMsg = '' }, 5000)
        },
        menuDelete(id){
            if (this.activeObj.id != '0')
                {
                    this.sendMsg = '-'
                    this.output = null
                    //let currentObj = this;

                    dataService.deleteExercice(id)
                    .then((response) => {
                        if(response.statusText == 'OK')
                        {
                            if(response.data)
                            {
                                this.fromApi = this.fromApi.map(exercice => {
                                    if(exercice.id == id)  exercice.isActive = !exercice.isActive;
                                    return exercice;
                                });
                                this.resetAll() 
                            }
                        }
                        this.sendMsg = ''
                    })
                    .catch((error) => {
                        this.sendMsg = error
                    });

                    //setTimeout(() => { this.sendMsg = '' }, 5000)

                }
        },
        createPeriods(qte){
            this.periodsList.splice(0);
            this.activeObj.numberOfPeriod = qte

            var i = 0
            for (i=0; i < qte; i++)
            {
                this.periodsList.push(this.periods)
            }
        },
        returnIsClosed(value) {
            if (value == false)
            {return "Ouverte"}
            else
            {return "Fermé"}
        }
        //addValue(){
        //    if(this.max)
        //    {
        //        if (this.activeObj.numberOfPeriod < this.max)
        //        {this.activeObj.numberOfPeriod = parseInt(this.activeObj.numberOfPeriod) + 1}
        //    }
        //    else
        //    {this.activeObj.numberOfPeriod = parseInt(this.activeObj.numberOfPeriod) + 1}
        //    
        //    this.createPeriods()
        //},
        //removeValue(){
        //    if(this.min)
        //    {
        //        if (this.activeObj.numberOfPeriod > this.min)
        //        {this.activeObj.numberOfPeriod = parseInt(this.activeObj.numberOfPeriod) - 1}
        //    }
        //    else
        //    {this.activeObj.numberOfPeriod = parseInt(this.activeObj.numberOfPeriod) - 1}
        //    
        //    this.createPeriods()
        //}
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        checkAllField() {
            //if (this.activeObj.description0 == '' || this.activeObj.startDate == null || this.activeObj.startDate == '')
            if (this.activeObj.description0 == '' )
            {return true}
            else
            {return false}
        },
        checkDeleteBtn() {
            return (this.activeObj.id != 0)
        },
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.loadApi() //charger les licences
        this.InitialState = this.$CObj(this.activeObj)
        this.createPeriods(12)
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
                this.loadApi()
            }
        },
        activeObj: function() {
            this.createPeriods(this.activeObj.numberOfPeriod)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/views/exercises.scss"
</style>